import React, {Component} from 'react';
import {Header, Image,Segment} from 'semantic-ui-react';
import Divider from "semantic-ui-react/dist/commonjs/elements/Divider/Divider";

class ViewClerkUserDetails extends Component {
    render() {
        const user = this.props.selectedObject[0];
        return (
            <div className="listing-container">
                <Header size="large" content="Clerk Details" textAlign="center"/>
                    <div>
                        <Segment>
                            <Header as="h4" content="Account Details:"/>
                            <Divider/>
                            <dl>
                                <dt>Name </dt>
                                <dd>{user.name}</dd>
                                <dt>Email</dt>
                                <dd>{user.email}</dd>
                                <dt>Mobile</dt>
                                <dd>{user['mobile_number']?user['mobile_number']:"NA"}</dd>
                            </dl>
                            <Header as="h4" content="Address Details:" />
                            <div>
                                {user['address']}
                            </div>
                            <Header as="h4" content="Documents"/>
                            <div>
                                <Image.Group size="small">
                                {user['insurance']['report']['url'] &&  <Image  as='a' label="Insurance Document" target='_blank' src={user['insurance']['report']['url']} href={user['insurance']['report']['url']} />}
                                {user['sign']['report']['url'] &&  <Image  as='a' label="Signature" target='_blank' src={user['sign']['report']['url']} href={user['sign']['report']['url']} />}
                                {user['license']['report']['url'] &&  <Image  as='a' label="License Document" target='_blank' src={user['license']['report']['url']} href={user['license']['report']['url']} />}
                                </Image.Group>
                                {!user['insurance']['report']['url'] && !user['sign']['report']['url'] && !user['license']['report']['url'] && <p>No Documents Provided</p>}
                            </div>
                        </Segment>
                    </div>

            </div>
        );
    }

}

export default ViewClerkUserDetails;


// WEBPACK FOOTER //
// ./src/views/user/clerk/view_user_details.js